import Button from '@/common/components/Button';
import Modal from '@/common/components/Modal';
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple';
import useUnblockClientCard from '../../hooks/useUnblockClientCard';

interface UnblockPersonalCardProps {
  userId?: string
  cardId?: string
}

const UnblockPersonalCard = ({ userId, cardId }: UnblockPersonalCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const queryClient = useQueryClient();

  const {
    mutate: unblockClientUserCard,
    isPending: isUnblockClientUserCardPending,
  } = useUnblockClientCard({
    cardId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companyUser', userId] });
      setIsOpen(false);
    },
    onError: (error) => {
      setMessages(error.response?.data.errors.base || ['Occorreu um erro ao desbloquear cartão.']);
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            type="button"
            operationKlassToCheckPermission="Admin::Client::Cards::Unblock"
            name="unblock_card"
          >
            Desbloquear cartão
          </Button>
        )}
        title="Você tem certeza?"
        subtitle="Se o cartão do usuário for desbloqueado, transações poderão ser feitas."
        titleClass="text-xl"
        subtitleClassName="mt-2 !text-[16px] text-white-300"
        showClose={false}
        useCancellableFooter
        onConfirm={() => unblockClientUserCard()}
        confirmButtonIsLoading={isUnblockClientUserCardPending}
        disabled={isUnblockClientUserCardPending}
        dataTestid="confirm_unblock_card"
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError
        />
      )}
    </>
  )
}

export default UnblockPersonalCard;
